// react
import React, { useEffect } from 'react';

// styled components
import { StyledObjectInfo } from './StyledObjectInfo';

// common
import SidebarContainer from 'common/SidebarContainer/SidebarContainer';


const ObjectInfo = ({ modelList, refetchModelList, modelListIsLoading, netStatus, setIsAnimation, setIsObjectTag }) => {
    useEffect(() => {
        setIsAnimation(false);
        setIsObjectTag(false);
    }, []);
    return (
        <SidebarContainer
            modelList={modelList}
            refetchModelList={refetchModelList}
            modelListIsLoading={modelListIsLoading}
            netStatus={netStatus}
        >
            <StyledObjectInfo>
            </StyledObjectInfo>
        </SidebarContainer>
    );
};

export default ObjectInfo;
